(function () {
    "use strict";

    cip_SaveAsDialog.okText = "Save";

    cip_SaveAsDialog.id = function () {
        return 'saveAsDialog';
    };

    cip_SaveAsDialog.title = function () {
        return 'Continue Later';
    };

    cip_SaveAsDialog.width = function () {
        return 450;
    };

    cip_SaveAsDialog.content = function () {
        return '' +
            '<div class="space-y-8">' +
                '<span>Please enter the following details</span>' +
                '<label id="saveAsEmailLabel">' +
                    '<span class="emailLabel">Email Address</span>' +
                    '<input name="saveAsEmail" class="form-control" type="text" />' +
                '</label>' +
                '<label id="saveAsMobilePhoneNumberLabel">' +
                    '<span class="mobilePhoneNumberLabel">Mobile Phone</span>' +
                    '<input name="saveAsMobilePhoneNumber" class="form-control" type="text" />' +
                '</label>' +
            '</div>';
    };

    cip_SaveAsDialog.unpopulate = function (isNew) {
        var saveAs = {};

        saveAs.email = $('#' + cip_SaveAsDialog.id() + " input[name=saveAsEmail]").getValue().trim();
        saveAs.mobilePhoneNumber = $('#' + cip_SaveAsDialog.id() + " input[name=saveAsMobilePhoneNumber]").getValue().trim();

        return saveAs;
    };

    cip_SaveAsDialog.populate = function (saveAs, isNew) {
        $('#' + cip_SaveAsDialog.id() + " input[name=saveAsEmail]").setValue(saveAs.email);
        $('#' + cip_SaveAsDialog.id() + " input[name=saveAsMobilePhoneNumber]").setValue(saveAs.mobilePhoneNumber);
    };

    cip_SendSmsCodeDialog.okText = "Send SMS Activation Code";

    cip_SendSmsCodeDialog.id = function () {
        return 'showSendSmsCodeDialog';
    };

    cip_SendSmsCodeDialog.title = function () {
        return 'Access';
    };

    cip_SendSmsCodeDialog.width = function () {
        return 450;
    };

    cip_SendSmsCodeDialog.content = function (data) {
        return "<p>" +
            "We need to send you a secure activation code. The activation code will be sent to your mobile phone (" + data.maskedMobilePhoneNumber + ").<br><br>" +
            "Press 'Send SMS Activation Code' to continue" +
            "</p>";
    };

    cip_ActivateUsingSmsCodeDialog.okText = "Activate";

    cip_ActivateUsingSmsCodeDialog.id = function () {
        return 'activateUsingSmsCodeDialog';
    };

    cip_ActivateUsingSmsCodeDialog.title = function () {
        return 'Enter SMS Activation Code';
    };

    cip_ActivateUsingSmsCodeDialog.width = function () {
        return 450;
    };

    cip_ActivateUsingSmsCodeDialog.content = function (data) {
        return '<p>A secure activation code has been sent to your mobile phone (' + data.maskedMobilePhoneNumber + ').</p>' +
            '<label id="activateUsingSmsCodeEmailLabel">' +
            '<span class="smsCodeLabel">Activation Code</span>' +
            '<input name="smsCode" class="form-control" type="text" />' +
            '</label>';
    };

    cip_ActivateUsingSmsCodeDialog.unpopulate = function (isNew) {
        var activateUsingSmsCode = {};

        activateUsingSmsCode.smsCode = $('#' + cip_ActivateUsingSmsCodeDialog.id() + " input[name=smsCode]").getValue();

        return activateUsingSmsCode;
    };

    cip_ActivateUsingSmsCodeDialog.populate = function (activateUsingSmsCode, isNew) {
        $('#' + cip_ActivateUsingSmsCodeDialog.id() + " input[name=smsCode]").setValue(activateUsingSmsCode.smsCode)
    };

    cip_ActivateUsingCustomerDetails.okText = "Activate";

    cip_ActivateUsingCustomerDetails.id = function () {
        return 'activateUsingCustomerDetailsDialog';
    };

    cip_ActivateUsingCustomerDetails.title = function () {
        return 'Restricted Access';
    };

    cip_ActivateUsingCustomerDetails.width = function () {
        return 450;
    };

    cip_ActivateUsingCustomerDetails.content = function (data) {
        return '<p>' +
            'We need to confirm some details before you can proceed.' +
            '</p>' +
            '<div style="padding-top: 10px;">' +
            '<b>Who is the primary customer?</b>' +
            '<label>' +
            '<span class="customerFirstNameLabel">First name</span>' +
            '<input name="customerFirstName" class="form-control" type="text"/>' +
            '<em>*</em>' +
            '</label>' +
            '<label>' +
            '<span class="customerLastNameLabel">Last name</span>' +
            '<input name="customerLastName" class="form-control" type="text"/>' +
            '<em>*</em>' +
            '</label>' +
            '<label>' +
            '<span class="customerEmailLabel">Email</span>' +
            '<input name="customerEmail" class="form-control" type="text"/>' +
            '<em>*</em>' +
            '</label>' +
            '</div>' +
            '<div style="padding-top: 20px;">' +
            '<b>About you</b>' +
            '<label>' +
            '<span class="representativeNameLabel">What is your name?</span>' +
            '<input name="representativeName" class="form-control" type="text"/>' +
            '<em>*</em>' +
            '</label>' +
            '</div>';
    };

    cip_ActivateUsingCustomerDetails.unpopulate = function (isNew) {
        var customerDetails = {};

        customerDetails.firstName = $('#' + cip_ActivateUsingCustomerDetails.id() + " input[name=customerFirstName]").getValue();
        customerDetails.lastName = $('#' + cip_ActivateUsingCustomerDetails.id() + " input[name=customerLastName]").getValue();
        customerDetails.email = $('#' + cip_ActivateUsingCustomerDetails.id() + " input[name=customerEmail]").getValue();
        customerDetails.representativeName = $('#' + cip_ActivateUsingCustomerDetails.id() + " input[name=representativeName]").getValue();

        return customerDetails;
    };

    cip_ActivateUsingCustomerDetails.populate = function (customerDetails, isNew) {
    };
})();